module.exports = __webpack_public_path__ + "e353b28a49bf50b9b4e3bec1a000da74.svg";